export default __webpack_public_path__ + "static/media/mpeg.539ada06.png";